import { useSearchParams } from 'react-router-dom';
import { Tabs } from '@/components/ui';
import { WorkspaceSettings } from '@/components/settings/WorkspaceSettings';
import { TeamSettings } from '@/components/settings/TeamSettings';
import { PipelineSettings } from '@/components/settings/PipelineSettings';
import { ListSettings } from '@/components/settings/ListSettings';
import { AuditLog, LeadFeedSettings } from '@/components/settings/FeedAndAudit';
import { TritoniqContacts } from '@/components/settings/TritoniqContacts';
import { LegacyImport } from '@/components/settings/LegacyImport';
import { Integrations } from '@/components/settings/Integrations';
import { PhoneSettings } from '@/components/settings/PhoneSettings';
import { useMe } from '@/auth/useMe';

const TABS = [
  { value: 'workspace', label: 'Workspace' }, { value: 'team', label: 'Team' }, { value: 'pipeline', label: 'Pipeline' },
  { value: 'lists', label: 'Lists' }, { value: 'tritoniq', label: 'tritonIQ' }, { value: 'integrations', label: 'Transcripts' }, { value: 'phone', label: 'Phone' }, { value: 'import', label: 'Import' }, { value: 'audit', label: 'Audit log' },
];

/* Owner/admin only (route and API). The tab lives in the URL so a link can point
   straight at, say, Team. */
export function Settings() {
  const [params, setParams] = useSearchParams();
  const { me } = useMe();
  const tab = TABS.find((t) => t.value === params.get('tab'))?.value ?? 'workspace';
  return (
    <div className="crm-list">
      <div className="lead-tabsbar"><Tabs items={TABS} value={tab} onChange={(v) => setParams({ tab: v }, { replace: true })} /></div>
      {tab === 'workspace' && <WorkspaceSettings />}
      {tab === 'team' && <TeamSettings />}
      {tab === 'pipeline' && <PipelineSettings />}
      {tab === 'lists' && <ListSettings />}
      {/* The lead feed works for any workspace; the contacts import is Triton-only. */}
      {tab === 'tritoniq' && <div className="crm-list"><LeadFeedSettings />{me?.workspace.isAgency && <TritoniqContacts />}</div>}
      {tab === 'integrations' && <Integrations />}
      {tab === 'phone' && <PhoneSettings />}
      {tab === 'import' && <LegacyImport />}
      {tab === 'audit' && <AuditLog />}
    </div>
  );
}
